"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorAlert = exports.StyledProductsPreviewContainer = exports.StyledProductPreviewSectionContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("../../../components");
exports.StyledProductPreviewSectionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1 px solid ${ui_components_1.baseColors.primaryGray200};
  box-shadow: ${ui_components_1.shadows.card};
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.palette.common.white};

  .products-preview-section-no-data {
    justify-content: center;
    flex: 1
  }

  .products-preview-section-loader {
    flex: 1;
  }
`;
exports.StyledProductsPreviewContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${ui_components_1.baseColors.white};
  border-radius: 4px;
  flex: 1;
`;
exports.StyledErrorAlert = (0, styled_components_1.default)(components_1.Alert) `
  align-self: flex-start;
`;
